import { render, staticRenderFns } from "./ProdutoDescricao.vue?vue&type=template&id=bfceaf02&scoped=true"
import script from "./ProdutoDescricao.vue?vue&type=script&lang=js"
export * from "./ProdutoDescricao.vue?vue&type=script&lang=js"
import style0 from "./ProdutoDescricao.vue?vue&type=style&index=0&id=bfceaf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfceaf02",
  null
  
)

export default component.exports